/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Linear, Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class FITHBigWinCountUp extends BitmapWinCountUp {
    private _winAmountBg: PIXI.Sprite;
    private _winAmountBgFlipped: PIXI.Sprite;
    private _winAmountBgContainer: PIXI.Container;
    private _bgTl: TimelineMax;

    constructor() {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: 50
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public getCountUpAnimation(from: number, to: number, duration: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this.updateItems();
                this.animateBGs();
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration: duration,
                ease: Linear.easeNone
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x: 0.5, y: 0.5},
                {
                    x: 1,
                    y: 1,
                    ease: Linear.easeNone
                })
        ]);

        return timeline;
    }

    public getEndingAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite({
            onComplete: () => {
                if (this._bgTl) {
                    this._bgTl.clear(true);
                    this._bgTl.kill();
                }
            }
        });
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        timeline.add(TweenLite.to([this._winAmountBgContainer, this._countUp], 0.2, {alpha: 0}), `+=0.8`); // stay a while after count up.

        return timeline;
    }

    protected initAnimations(): void {
        super.initAnimations();

        this._winAmountBg = new PIXI.Sprite(GameResources.getTextures("bigWinAmountBg")[0]);
        this._winAmountBg.visible = false;
        this._winAmountBg.anchor.set(0.5);

        this._winAmountBgFlipped = new PIXI.Sprite(GameResources.getTextures("bigWinAmountBg")[0]);
        this._winAmountBgFlipped.visible = false;
        this._winAmountBgFlipped.anchor.set(0.5);
        this._winAmountBgFlipped.scale.x *= -1;

        this._winAmountBgContainer = new PIXI.Container();
        this._winAmountBgContainer.addChild(this._winAmountBg, this._winAmountBgFlipped);

        this._countUpContainer.addChildAt(this._winAmountBgContainer, 0);
    }

    protected getAbortAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => this.updateItems(),
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x: 0.5, y: 0.5},
                {
                    x: 1,
                    y: 1,
                    ease: Linear.easeNone
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);

        return timeline;
    }

    private updateItems(): void {
        this._winAmountBg.visible = true;
        this._winAmountBgFlipped.visible = true;

        this._winAmountBgContainer.alpha = 1;
        this._winAmountBgContainer.visible = true;
        this._winAmountBgContainer.width = this._countUp.width * 1.5;
        this._winAmountBgContainer.height = this._countUp.height * 1.5;

        this._countUp.alpha = 1;
        this._countUp.visible = true;
    }

    private animateBGs(): void {
        const duration: number = 15 / 30,
            scale1: number = 1,
            scale2: number = 1.05,
            alpha1: number = 1,
            alpha2: number = 0.5;

        if (this._bgTl) {
            this._bgTl.clear(true);
            this._bgTl.kill();
        }
        this._bgTl = new TimelineMax({repeat: -1, yoyo: true});

        this._bgTl.fromTo(this._winAmountBg.scale, duration, {
            x: scale1,
            y: scale1
        }, {
            x: scale2,
            y: scale2,
            ease: Linear.easeNone
        }, 0);
        this._bgTl.fromTo(this._winAmountBg.scale, duration, {
            x: scale2,
            y: scale2
        }, {
            x: scale1,
            y: scale1,
            ease: Linear.easeNone
        }, duration);

        this._bgTl.fromTo(this._winAmountBg, duration / 2, {
            alpha: alpha1
        }, {
            alpha: alpha2,
            ease: Linear.easeNone
        }, 0);
        this._bgTl.fromTo(this._winAmountBg, duration / 2, {
            alpha: alpha2
        }, {
            alpha: alpha1,
            ease: Linear.easeNone
        }, duration / 2);
        this._bgTl.fromTo(this._winAmountBg, duration / 2, {
            alpha: alpha1
        }, {
            alpha: alpha2,
            ease: Linear.easeNone
        }, duration);
        this._bgTl.fromTo(this._winAmountBg, duration / 2, {
            alpha: alpha2
        }, {
            alpha: alpha1,
            ease: Linear.easeNone
        }, duration * (3 / 4));

        this._bgTl.fromTo(this._winAmountBgFlipped.scale, duration, {
            x: -scale2,
            y: scale2
        }, {
            x: -scale1,
            y: scale1,
            ease: Linear.easeNone
        }, 0);
        this._bgTl.fromTo(this._winAmountBgFlipped.scale, duration, {
            x: -scale1,
            y: scale1
        }, {
            x: -scale2,
            y: scale2,
            ease: Linear.easeNone
        }, duration);

        this._bgTl.fromTo(this._winAmountBgFlipped, duration / 2, {
            alpha: alpha2
        }, {
            alpha: alpha1,
            ease: Linear.easeNone
        }, 0);
        this._bgTl.fromTo(this._winAmountBgFlipped, duration / 2, {
            alpha: alpha1
        }, {
            alpha: alpha2,
            ease: Linear.easeNone
        }, duration / 2);
        this._bgTl.fromTo(this._winAmountBgFlipped, duration / 2, {
            alpha: alpha2
        }, {
            alpha: alpha1,
            ease: Linear.easeNone
        }, duration);
        this._bgTl.fromTo(this._winAmountBgFlipped, duration / 2, {
            alpha: alpha1
        }, {
            alpha: alpha2,
            ease: Linear.easeNone
        }, duration * (3 / 4));
    }
}